import { IGroupSet } from '../types/tasks.types'
import http, { handleHttpError, handleHttpResponse } from '../shared/http'
import { IPack } from './packs/packs.types'
import { HTTPResponse } from '../shared/http/http.types'

const getPackSets = async (packId: IPack['id']): Promise<IGroupSet[]> => {
  return http.get(`/api/v1/admin/exercise_sets/?pack=${packId}&limit=100`).then((r) => r.data.results)
}

const createSet = async (packId: IPack['id'], level = undefined): Promise<IGroupSet> => {
  return http.post('/api/v1/admin/exercise_sets/', { pack: packId, level }).then((r) => r.data)
}

const update = async (id: IGroupSet['id'], updates: Partial<IGroupSet>): Promise<HTTPResponse<IGroupSet>> => {
  return http.patch(`/api/v1/admin/exercise_sets/${id}/`, updates).then(handleHttpResponse).catch(handleHttpError)
}

const deleteSet = async (setId: IPack['id']): Promise<HTTPResponse<IGroupSet>> => {
  return http
    .delete('/api/v1/admin/exercise_sets/' + setId + '/')
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const setsService = {
  createSet,
  getPackSets,
  deleteSet,
  update,
}
export default setsService
